import router from '@/plugins/router'
import defaultAvatar from '@/assets/img/default-avatar.svg'

export default {
  connectionType: state => {
    return state.activity.from.allConnections[0].type
  },
  callStatus: state => {
    return state.activity.status === 'pending'
      ? 'dialling'
      : state.activity.status
  },
  recordingState: state => {
    return state.activity.recordingState
  },
  hasDialpad: (state, getters) => {
    return getters.connectionType === 'web-rtc'
  },
  hasMuteButton: (state, getters) => {
    return getters.connectionType === 'web-rtc'
  },
  contactName (state) {
    if (state.activity.prospect && state.activity.prospect.name) {
      return state.activity.prospect.name
    } else if (router.currentRoute.query.name) {
      return router.currentRoute.query.name
    }

    return ''
  },
  contactPhotoUrl (state) {
    if (state.activity.prospect && state.activity.prospect.photoUrl) {
      return state.activity.prospect.photoUrl
    } else if (router.currentRoute.query.photoUrl) {
      return router.currentRoute.query.photoUrl
    }

    return defaultAvatar
  },
  contactPosition (state) {
    if (
      state.activity.prospect &&
      state.activity.prospect.title &&
      ['lead', 'contact'].includes(state.activity.prospect.type)
    ) {
      return state.activity.prospect.title
    }

    return null
  },
  contactOrganization (state) {
    if (state.activity.prospect) {
      const { type, account, company } = state.activity.prospect

      if (type === 'lead' && company) {
        return company
      }

      if (type === 'contact' && account && account.name) {
        return account.name
      }
    }

    return null
  },
  contactNumber (state) {
    return state.activity.to.formattedPhone
  },
  numPrivateMessages: state => {
    return state.activity.privateMessages.length
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/conference/getters.js